import JCE from '@chesscom/js-chess-engine';
import type { API } from 'chessboard/api/config/types';
import { Game } from 'chessboard/model/game/types';
import { getBughouseGameTimeValues } from 'chessboard/api/model/get-bughouse-game-time-values';

/**
 * Create createGame API method.
 */
export function createCreateGame(context: API.Context) {
  /**
   * Create a new JCE game.
   */
  return function createGame(options: API.CreateGameParams): API.Response | undefined {
    const newGame = JCE.createGame({
      timestamps: options.times || options.timestamps || undefined,
      ...options,
      analysis: true,
      autoPromote: true,
    });

    if (!newGame) {
      return;
    }

    const { api } = context;
    let { times, timestamps } = options;

    if (options.variant === Game.Variants.Bughouse) {
      times = getBughouseGameTimeValues(times);
      timestamps = getBughouseGameTimeValues(timestamps);
    }

    return api.load({
      pgn: newGame.pgn({ useResultHeader: true }),
      variant: options.variant as Game.Variants,
      times,
      timestamps,
      premoves:
        newGame.premove.queue && newGame.premove.queue.length > 0
          ? newGame.premove.queue
          : undefined,
    });
  };
}
